import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

export const roleAuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const userRole = authService.snapshot?.userRole ?? null;

  if (!userRole) {
    router.navigate(['/login']);
    return false;
  }

  const requiredRoles: string[] = route.data?.['roles'] || [];
  if (!requiredRoles.includes(userRole)) {
    router.navigate([authService.getLandingPageForRole(userRole)]);
    return false;
  }

  return true;
};
